import { fixNameEnum } from '@/modules/common/utils/enum-fix.ts';

export const enumToOptions = <T extends Record<string, string>>(enumObj: T) =>
  Object.values(enumObj).map(value => ({
    label: fixNameEnum(value) || value.replace(value[0], value[0].toUpperCase()),
    value: value,
  }));
